export const CMSContentSlotPositions = Object.freeze({
  TOP_SLOT: 'TopSlot',
  CENTER_LEFT_TOP_SLOT: 'CenterLeftTopSlot',
  CENTER_LEFT_BOTTOM_SLOT: 'CenterLeftBottomSlot',
  CENTER_RIGHT_SLOT: 'CenterRightSlot',
  BOTTOM_SLOT: 'BottomSlot',
});
